<div class="layerContainer">
  @if ((selectedTab$ | async) == TunifyV5Tab.HOME) {
    <tun-home-panel class="layer"></tun-home-panel>
  }
  @if ((selectedTab$ | async) == TunifyV5Tab.CALENDAR) {
    <tun-calendars-panel class="layer"></tun-calendars-panel>
  }
  @if ((selectedTab$ | async) == TunifyV5Tab.MUSIC_CHANNEL) {
    <tun-music-channels-panel class="layer"></tun-music-channels-panel>
  }
  @if ((selectedTab$ | async) == TunifyV5Tab.PLAYLIST) {
    <tun-playlists-panel class="layer"></tun-playlists-panel>
  }
  @if ((selectedTab$ | async) == TunifyV5Tab.SEARCH) {
    <tun-search-panel class="layer"></tun-search-panel>
  }
  @if ((selectedTab$ | async) == TunifyV5Tab.SETTINGS) {
    <tun-settings-panel class="layer"></tun-settings-panel>
  }
</div>
